export default {
  primary: '#a51d22',
  secondary: '#a51d22',
  text: '#fff',
  background: 'black',
  backgroundSecondary: 'black',
  light: '#FFF',
  dark: '#202020'
}
